<template>
  <Card
    title="Public Playlist"
    subtitle="Toggle on to enable public playlist on home page"
  >
    <template v-slot:button>
      <div class="w-64 font-bold h-10 mt-3 text-gray-800 flex justify-end">
        <label
          for="togglePublicPlaylist"
          class="flex items-center cursor-pointer"
        >
          <!-- toggle -->
          <div class="relative">
            <!-- input -->
            <input id="togglePublicPlaylist" type="checkbox" v-model="togglePublicPlaylist" class="hidden" @change="onTogglePublicPlaylist"  />
            <!-- line -->
            <div class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"></div>
            <!-- dot -->
            <div class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"></div>
          </div>
          <!-- label -->
        </label>
      </div>
    </template>
    <template v-slot:body>
      <div >
        <div class="flex border-b border-gray-200 py-3 justify-between">
          <div class="flex flex-col">
            <h5 class="text-gray-700 text-sm py-2 font-bold uppercase">
              Playlist List
            </h5>
          </div>
          <router-link :to="{ name: 'AddPlaylist' }">
            <a  class="text-sm focus:outline-none px-4 py-2 rounded font-bold cursor-pointer
                          hover:bg-blue-700 hover:text-blue-100
                          text-blue-700
                            border duration-200 ease-in-out
                          border-blue-600 transition">Create Playlist</a>
          </router-link>
        </div>
        <div class="flex py-3">
          <div class="w-full p-3">
            <el-table-draggable @sort="onSort"  handle=".handle-move" >
              <el-table :data="listPlaylists" row-key="id" :show-header="false" style="width: 100%">
                <el-table-column label="Handle" align="center" key="handle">
                  <div class="static inline-block text-center container-action handle-move" style="cursor: move">
                    <font-awesome-icon size="2x" :icon="['fa', 'th']" />
                  </div>
                </el-table-column>
                <el-table-column label="Cover" key="cover">
                  <template slot-scope="scope">
                    <div class="static inline-block text-center container-action">
                      <img :src="scope.row.cover" style="width: 100px;height: 100px;object-fit: cover" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column v-for="column in tableColumn" :prop="column.prop" :label="column.label" :key="column.prop" sortable="custom">
                </el-table-column>
                <el-table-column label="Actions" align="right">
                  <template slot-scope="scope">
                    <div class="static inline-block text-left container-action">
                      <VueCustomTooltip label="Edit" :position="'is-left'">
                        <router-link :to="{ name: 'EditPlaylist', params: { id: scope.row.id }}">
                          <a  class="p-2 mr-2 rounded bg-yellow-500 hover:bg-yellow-600 focus:outline-none" >
                            <font-awesome-icon class="text-white" :icon="['fa', 'pencil-alt']" />
                          </a>
                        </router-link>
                      </VueCustomTooltip>
                      <VueCustomTooltip label="Delete" :position="'is-left'">
                        <button @click="deletePlaylist(scope.row)" class="p-2 mr-2 rounded bg-red-500 hover:bg-red-600 focus:outline-none" >
                          <font-awesome-icon class="text-white" :icon="['fa', 'trash-alt']" />
                        </button>
                      </VueCustomTooltip>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="Toggle" class="text-center" >
                  <template slot-scope="scope">
                    <label
                      :for="'toogle'+scope.row.id"
                      class="flex items-center"
                      :class="'cursor-pointer'"
                      style="height: 50px;"
                    >
                      <!-- toggle -->
                      <div class="relative m-auto">
                        <!-- input -->
                        <input
                          :id="'toogle'+scope.row.id"
                          v-model="scope.row.status"
                          @change="setStatusPlaylist(scope.row)"
                          type="checkbox"
                          class="hidden"
                        />
                        <!-- line -->
                        <div
                          class="toggle__line w-10 h-4 bg-gray-400 rounded-full shadow-inner"
                        ></div>
                        <!-- dot -->
                        <div
                          class="toggle__dot absolute w-6 h-6 bg-white rounded-full shadow inset-y-0 left-0"
                        ></div>
                      </div>
                      <!-- label -->
                    </label>
                  </template>
                </el-table-column>
              </el-table>
            </el-table-draggable>

          </div>
        </div>
      </div>
    </template>
  </Card>
</template>

<script>
import Vue from 'vue';
import ElTableDraggable from 'el-table-draggable';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import { mapActions, mapGetters } from 'vuex';
import Card from '@/components/Layout/Card';
import { Button } from '@/components/Layout/Form';
export default {
  name: 'ListPlaylist',
  data: () => ({
    togglePublicPlaylist: false,
    listPlaylists: [],
    tableColumn: [
      {
        prop: 'title',
        label: 'Title',
      },
      {
        prop: 'total_song',
        label: 'Songs',
      },
      {
        prop: 'total_play',
        label: 'Plays',
      },
    ],
  }),
  computed: {
    ...mapGetters('NotificationModule', ['getErrorCode', 'getMessage', 'getStatus']),
    ...mapGetters('PlaylistModule', ['listPlaylist']),
  },
  async mounted() {
    const status = await this.requestGetStatusPublicPlaylist();
    this.togglePublicPlaylist = status.status == 1;
    await this.requestGetListPlaylist();
  },
  methods: {
    ...mapActions('PlaylistModule', ['requestGetListPlaylist', 'requestGetStatusPublicPlaylist',
      'requestSetStatusPublicPlaylist', 'requestReOrderPlaylist', 'requestDeletePlaylist', 'requestSetStatusPlaylist']),
    async onTogglePublicPlaylist() {
      await this.requestSetStatusPublicPlaylist({
        status: this.togglePublicPlaylist,
      });
    },
    async onSort(evt) {
      setTimeout(async () => {
        const ids = this.listPlaylists.map(play => play.id);
        await this.requestReOrderPlaylist({
          id: ids,
        });
      }, 500);
    },
    async deletePlaylist(playlist) {
      Vue.swal({
        title: 'Delete Data!',
        text: `Are you sure to delete playlist: ${playlist.title}`,
        icon: 'warning',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        showCancelButton: true,
      }).then(async (result) => {
        if (result.value) {
          await this.requestDeletePlaylist({
            id: playlist.id,
          });
          this.$swal('Deleted', `You successfully delete playlist: ${playlist.title}`, 'success');
          // this.idAlbum = '';
        }
      });
    },
    async setStatusPlaylist(playlist) {
      const status = {
        id: playlist.id,
        status: playlist.status,
      };
      await this.requestSetStatusPlaylist(status);
    },
  },
  watch: {
    listPlaylist: {
      immediate: true,
      deep: true,
      async handler(val) {
        if (this.listPlaylist.data != null && this.listPlaylist.data != undefined) {
          this.listPlaylists = this.listPlaylist.data.map(play => ({ ...play, total_song: `${play.total_song} Songs`, total_play: `${play.total_play} Plays` }));
        }
      },
    },
  },
  components: {
    ElTableDraggable, VueCustomTooltip, Card, Button
  },
};
</script>

<style scoped>
.toggle__dot {
  top: -.25rem;
  left: -.25rem;
  transition: all 0.3s ease-in-out;
}

input:checked ~ .toggle__dot {
  transform: translateX(100%);
  background-color: #48bb78;
}
</style>



// WEBPACK FOOTER //
// src/views/Playlist/List.vue